import { FaCog } from "react-icons/fa"
import PaginationPage from "./Pagination/index"
import HeaderPage from "./Header/index"

export default function Page({carrying, setCarrying, URL, search, setSearch, itensByPage, setItensByPage, page, setPage, limit, children}){
    return (
        <>
            {carrying && <div className="content">
                    <div className="divCarrying">
                        <span>Carregando..</span>
                        <FaCog icon="spinner" className="spinner" />
                    </div>
            </div>}
            {!carrying && <div className="content">
                <HeaderPage title="URLs" URL={"urls"} itensByPage={itensByPage} setItensByPage={setItensByPage} search={search} setSearch={setSearch} />
                {children}
                <PaginationPage page={page} setPage={setPage} limit={limit} />
            </div>}
        </>
    )
}